import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/payment-actions';
import { PaymentActions } from '../constants';
import { IPayment } from 'src/types/payment';

export interface PaymentState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IPayment>;
    current: IPayment | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        inProgress: false,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function payments(state: PaymentState = initialState, action: Actions | any): PaymentState {
    switch (action.type) {
        case requestType(PaymentActions.FETCH_PAYMENTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(PaymentActions.FETCH_PAYMENTS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(PaymentActions.FETCH_PAYMENTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(PaymentActions.FETCH_PAYMENT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(PaymentActions.FETCH_PAYMENT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(PaymentActions.FETCH_PAYMENT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(PaymentActions.DELETE_PAYMENT):
            return { ...state, inProgress: true, error: '' };
        case successType(PaymentActions.DELETE_PAYMENT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IPayment) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(PaymentActions.DELETE_PAYMENT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
